import { render, staticRenderFns } from "./SalonLocalization.vue?vue&type=template&id=bccdfe00&scoped=true&"
import script from "./SalonLocalization.vue?vue&type=script&lang=js&"
export * from "./SalonLocalization.vue?vue&type=script&lang=js&"
import style0 from "./SalonLocalization.vue?vue&type=style&index=0&id=bccdfe00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccdfe00",
  null
  
)

export default component.exports